// extracted by mini-css-extract-plugin
export default {"home":"HomeUI_home__mqDa9","home--backdrop":"HomeUI_home--backdrop__kaMMo"};